import IroningBannerImage from 'core/assets/images/ironing-banner.webp';
import SewingBannerImage from 'core/assets/images/sewing-banner.webp';
import HomeBannerImage from 'core/assets/images/home-banner.webp';
import HomeAboutUsImage from 'core/assets/images/home-about-us.webp';
import DryCleaningImage from 'core/assets/images/dry-cleaning.webp';
import LogoImage from 'core/assets/images/logo.png';

const Images = {
  IroningBannerImage,
  SewingBannerImage,
  HomeBannerImage,
  LogoImage,
  HomeAboutUsImage,
  DryCleaningImage,
};

export default Images;
